import FAQArticlePage from "./FAQArticle";

const data = {
  title: "What if I never received the product or service?",
  category: "Subscription Management",
  content: `If you never received the product or service you subscribed to, we're here to help resolve this issue promptly.

Steps to take:
1. Check your email (including spam/junk folders) for any delivery confirmations or access links
2. Verify that you used the correct email address when signing up
3. If you still cannot access the product or service, contact our support team immediately

What we'll do:
- We'll verify your subscription and payment status
- We'll investigate any delivery issues on our end
- We'll provide you with access or a full refund if the service cannot be delivered
- We'll keep you updated throughout the resolution process

You may also submit a dispute form if you prefer:
Go to Help Center > Dispute Resolution Form

Our goal is to ensure you receive what you paid for, or receive a full refund if delivery is not possible.

Email: support@novavertextech.com
Phone: +44 7520 663474`,
};

export default function SMQ3Page() {
  return <FAQArticlePage data={data} />;
}